import {observer} from 'mobx-react-lite';
import React, {useCallback} from 'react';

import {PaginationArguments, PaginationResponse} from '_/utilities/types';

import {StyledItem} from './styles';

/** @deprecated Use EFilter instead. */
export type Item = {
  id: string;
  text: string;
  Icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  subItems?: Item[];
  source?: (arg0: PaginationArguments & {query?: string}) => {
    promise: Promise<PaginationResponse<Item>>;
    abort: () => void;
  };
};

/** @deprecated Use EFilter instead. */
interface Props {
  onActivate: (item: Item) => void;
  className?: string;
  item: Item;
  active?: boolean;
  Icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

/** @deprecated Use EFilter instead. */
export function ItemComponent({
  active,
  className,
  onActivate,
  item,
}: Props): React.ReactElement {
  const handleClick = useCallback(() => {
    onActivate(item);
  }, [item, onActivate]);

  return (
    <StyledItem active={active} className={className} onClick={handleClick}>
      {item.text}
    </StyledItem>
  );
}

/** @deprecated Use EFilter instead. */
export default observer(ItemComponent);
